import Header from "components/templates/Header";
import AppModal from "components/templates/AppModal";
import AppRoutes from "routes/AppRoutes";
import ForceChangePasswordGate from "components/templates/ForceChangePasswordGate";
import { useAppSelector } from "redux/hooks";

export default function AppShell() {
  const user = useAppSelector((state) => state.auth.user);
  const hideChrome = !!user?.mustChangePassword;

  return (
    <>
      {!hideChrome && <Header />}
      {!hideChrome && <AppModal />}
      <ForceChangePasswordGate />
      <AppRoutes />
    </>
  );
}
